import React from 'react'

import {
  Body,
  Card,
  LinkText,
  Caption,
  Layout,
  LayoutWrapper,
  ContentAlignment,
  Display,
  Keyline,
} from 'shared-global-ec-uikit/components/dist/react/esm'

import { WrappedComponentProps } from 'react-intl'
import getConstants from '../../constants'
import Meta from '../Meta'

type Props = WrappedComponentProps

export const NotFound: React.FC<Props> = ({ intl }) => {
  const { CONTACT_US_URL, BRAND, BASE_URL: homePageUrl } = getConstants()
  return (
    <>
      <div className="fr-ec-mb-spacing-06" />
      <LayoutWrapper element="div">
        <Layout element="div" colSpan={{ sm: 4, md: 10, lg: 8, xl: 10 }} gutter>
          <Meta
            title={intl.formatMessage({ id: 'text_404' })}
            description={intl.formatMessage({
              id: 'text_404_error_description',
            })}
          />
          <Card
            element="div"
            padding="large"
            variant="border"
            className="fr-ec-mb-spacing-06"
            data-test="temporary-unavailable"
          >
            <ContentAlignment
              alignment="stretch"
              direction="column"
              element="div"
            >
              <Display
                variant="display2"
                element="h1"
                className="fr-ec-mb-spacing-06"
              >
                {intl.formatMessage({ id: 'text_404' })}
              </Display>
              <Keyline className="fr-ec-mb-spacing-05" />
              <Body element="p" className="fr-ec-mb-spacing-02">
                {intl.formatMessage({
                  id: 'text_404_error_description-1',
                })}
              </Body>
              <Body element="p" className="fr-ec-mb-spacing-02">
                {intl.formatMessage({
                  id: 'text_404_error_description-2',
                })}
              </Body>
              <Body element="p" className="fr-ec-mb-spacing-02">
                {intl.formatMessage({
                  id: 'text_404_error_description-3',
                })}
              </Body>
              <Body element="p" className="fr-ec-mb-spacing-05">
                {intl.formatMessage({
                  id: 'text_404_error_description-4',
                })}
              </Body>
              <Body element="div" className="fr-ec-mb-spacing-05">
                <LinkText element="a" href={homePageUrl}>
                  <Caption
                    variant="emphasized"
                    element="p"
                    className="fr-ec-mb-spacing-02"
                  >
                    {intl.formatMessage({
                      id: `text_go_to_top_${BRAND}`,
                    })}
                  </Caption>
                </LinkText>
                <LinkText element="a" href={CONTACT_US_URL}>
                  <Caption variant="emphasized" element="p">
                    {intl.formatMessage({ id: 'text_contactus' })}
                  </Caption>
                </LinkText>
              </Body>
            </ContentAlignment>
          </Card>
        </Layout>
      </LayoutWrapper>
    </>
  )
}
